// TierPromotionCardSemiDumb - accepts a PapiDeviation + CTA button type
// and turns it into primitive attributes of TierPromotionCardDumb
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import SubscribeButton from '../../Button/SubscribeButton';
import EditTierButton from '../../Tier/EditTierButton';
import TierPromotionCardDumb from '../TierPromotionCardDumb';
import VerticalTierPromotionCardDumb from '../VerticalTierPromotionCardDumb';
import { getTierDescription } from '../_helpers';
import SubscribeVariant from '../../Button/SubscribeButton/variants/Subscribe';
import DummySubscribedVariant from '../../Button/SubscribeButton/variants/DummySubscribed';
import { useDeviationMatureFilter } from '../../utils/hooks/useDeviationMatureFilter';
import HiddenOverlay from '../HiddenOverlay';
import s from './TierPromotionCardSemiDumb.scss';
const TierPromotionCardSemiDumb = (_param)=>{
    var { deviation, ctaButton, ctaClassname, wrapperClassName, verticalLayout } = _param, props = _object_without_properties(_param, [
        "deviation",
        "ctaButton",
        "ctaClassname",
        "wrapperClassName",
        "verticalLayout"
    ]);
    const [matureFilterOverridden, setMatureFilterOverridden] = useState(false);
    const { showBlocked, overrideMatureFilter } = useDeviationMatureFilter(deviation);
    const onOverrideFilterClick = useCallback(()=>{
        overrideMatureFilter();
        setMatureFilterOverridden(true);
    }, [
        overrideMatureFilter
    ]);
    if (!deviation.tier) {
        return null;
    }
    const { title = '', author, tier, coverImage } = deviation;
    const { dollarPrice, stats, state } = tier || {};
    let ctaButtonNode;
    switch(ctaButton){
        case 'subscribe':
            ctaButtonNode = /*#__PURE__*/ React.createElement(SubscribeButton, {
                className: ctaClassname,
                type: 'subscribe',
                tier: deviation,
                matureFilterDisabled: true
            });
            break;
        case 'view':
            ctaButtonNode = /*#__PURE__*/ React.createElement(SubscribeButton, {
                className: ctaClassname,
                type: 'view',
                tier: deviation,
                matureFilterDisabled: true
            });
            break;
        case 'view-subscribed':
            ctaButtonNode = /*#__PURE__*/ React.createElement(DummySubscribedVariant, {
                className: ctaClassname,
                onClick: props.onClick
            });
            break;
        case 'view-subscribe':
            ctaButtonNode = /*#__PURE__*/ React.createElement(SubscribeVariant, {
                className: ctaClassname,
                tier: deviation
            });
            break;
        case 'edit':
            ctaButtonNode = /*#__PURE__*/ React.createElement(EditTierButton, {
                className: ctaClassname,
                tier: deviation
            });
            break;
        case 'disabled':
            ctaButtonNode = /*#__PURE__*/ React.createElement(SubscribeButton, {
                className: ctaClassname,
                type: 'disabled',
                tier: deviation
            });
            break;
        default:
    }
    const Card = verticalLayout ? VerticalTierPromotionCardDumb : TierPromotionCardDumb;
    const rootClasses = classnames(s['card-root'], verticalLayout && s['vertical'], wrapperClassName);
    return /*#__PURE__*/ React.createElement("div", {
        className: rootClasses
    }, showBlocked && /*#__PURE__*/ React.createElement(HiddenOverlay, {
        className: s['card-overlay'],
        compact: true,
        showBackground: false,
        deviation: deviation,
        overrideMatureFilter: onOverrideFilterClick
    }), /*#__PURE__*/ React.createElement(Card, _object_spread({
        className: s['card'],
        author: author,
        coverImage: coverImage,
        showMatureCover: showBlocked || matureFilterOverridden,
        title: title,
        description: getTierDescription(deviation),
        stats: stats,
        isBoosted: deviation.boosted,
        price: dollarPrice,
        ctaButton: ctaButtonNode,
        state: state
    }, props)));
};
TierPromotionCardSemiDumb.displayName = 'TierPromotionCardSemiDumb';
export default TierPromotionCardSemiDumb;

//# sourceMappingURL=TierPromotionCardSemiDumb.js.map